<template>
    <modal id="confirm-acceptance-document-information" noPadding>
        <template slot="title">Verification</template>
        <template slot="body">

            <div class="px-3 pt-3 pb-2">
                <div class="nav-app">

                    <div class="nav-tabs-container">
                        <ul class="nav nav-tabs" id="nav-tab" role="tablist">
                            <li>
                                <a class="nav-link active" id="att-tab" data-toggle="tab" href="#att" role="tab" aria-controls="att" aria-selected="true">Technician</a>
                            </li>
                            <li>
                                <a class="nav-link" id="ate-tab" data-toggle="tab" href="#ate" role="tab" aria-controls="ate" aria-selected="true">Employer</a>
                            </li>
                            <li>
                                <a class="nav-link" id="work-team-tab" data-toggle="tab" href="#author" role="tab" aria-controls="author" aria-selected="true">Author</a>
                            </li>
                        </ul>
                    </div>

                    <div class="tab-content">
                        <div class="tab-pane active p-0" id="att" role="tabpanel" aria-labelledby="att-tab">
                            <table class="table table-striped border table-sm">
                                <tr>
                                    <td>Name</td>
                                    <td v-text="responsible.name"></td>
                                </tr>
                                <tr>
                                    <td>Company Name</td>
                                    <td v-text="responsible.profile.company"></td>
                                </tr>
                                <tr>
                                    <td>ATT No</td>
                                    <td v-text="responsible.att_number"></td>
                                </tr>
                                <tr>
                                    <td>Title</td>
                                    <td>Acceptance Test Technician</td>
                                </tr>
                                <tr>
                                    <td>Phone</td>
                                    <td v-text="responsible.profile.phone"></td>
                                </tr>
                            </table>
                        </div>
                        <div class="tab-pane p-0" id="ate" role="tabpanel" aria-labelledby="ate-tab">
                            <table class="table table-striped border table-sm">
                                <tr>
                                    <td>Name</td>
                                    <td v-text="employer.name"></td>
                                </tr>
                                <tr>
                                    <td>Company Name</td>
                                    <td v-text="employer.profile.company"></td>
                                </tr>
                                <tr>
                                    <td>Lic. No.</td>
                                    <td v-text="employer.profile.cslb_license"></td>
                                </tr>
                                <tr>
                                    <td>ATE No</td>
                                    <td v-text="employer.employer_number"></td>
                                </tr>
                                <tr>
                                    <td>Title</td>
                                    <td>Acceptance Test Employer</td>
                                </tr>
                                <tr>
                                    <td>Phone</td>
                                    <td v-text="employer.profile.phone"></td>
                                </tr>
                            </table>
                        </div>
                        <div class="tab-pane p-0" id="author" role="tabpanel" aria-labelledby="author-tab">
                            <table class="table table-striped border table-sm" v-if="author">
                                <tr>
                                    <td>Name</td>
                                    <td v-text="author.name"></td>
                                </tr>
                                <tr>
                                    <td>Company Name</td>
                                    <td v-text="author.company"></td>
                                </tr>
                                <tr>
                                    <td>Phone</td>
                                    <td v-text="author.phone"></td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </div>
            </div>

            <div class="p-4">

                <p class="text-muted mb-4">
                    <span class="font-weight-bolder">Building Permit Number</span>: <span v-text="project.permit_number"></span>.
                </p>

                <field-checkbox class="mb-2" v-model="nrciDocuments"
                                placeholder="I have verified that all NRCI forms are completed and signed."></field-checkbox>

            </div>
        </template>
        <template slot="footer">
            <button class="btn btn-default" @click="closeModal('confirm-acceptance-document-information')">Cancel</button>
            <button class="btn btn-success" :disabled="!nrciDocuments" @click="confirm()">Confirm</button>
        </template>
    </modal>
</template>
<script>
    export default {
        props: ['project', 'employer', 'responsible', 'author'],

        data(){
            return {
                nrciDocuments: false,
            }
        },

        methods:{
            confirm(){
                this.redirectTo(`/projects/${this.project.slug}/acceptance-documents/signature`)
            }
        }
    }
</script>
